import { FC } from 'react'
import styled from 'styled-components'

import { Icon, IconColor, IconSize, IconTypes } from './Icon'

interface CheckboxProps {
    className?: string;
    checked?: boolean;
    disabled?: boolean;
    onClick?: (selected: boolean) => void;
    selectedColor?: IconColor;
    uncheckedColor?: IconColor;
    width?: IconSize | number;
    height?: IconSize | number;
    size?: IconSize | number;
}

const Checkbox: FC<CheckboxProps> = ({
  className,
  checked = false,
  disabled = false,
  onClick,
  selectedColor,
  uncheckedColor,
  width,
  height,
  size
}) => {
  const onCheck = () => {
    if (!disabled && onClick) {
      onClick(!checked)
    }
  }

  const selectedIconColor = selectedColor ? selectedColor : IconColor.success
  const uncheckedIconColor = uncheckedColor ? uncheckedColor : IconColor.grayDark

  return (
    <StyledContainer className={className} onClick={onCheck}>
      {
        checked ?
          <Icon
            type={IconTypes.checkboxChecked}
            color={disabled ? IconColor.grayDark : selectedIconColor}
            width={width}
            height={height}
            size={size}
          /> :
          <Icon
            type={IconTypes.checkboxUnchecked}
            color={disabled ? IconColor.grayLight : uncheckedIconColor}
            width={width}
            height={height}
            size={size}
          />
      }
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: baseline;
`

export default Checkbox
